import React from "react"
import { Alert, Button, Dialog, DialogActions, DialogContent } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import { COLORS } from "../../../../../utils"
import { REUSABLE_STEP_URL, REUSABLE_STEP_VIEW_URL } from "../../../../../actions/Steps/reusableProductionSteps."


const useStyles = makeStyles(() => ({
    dialog: {
        "& .MuiPaper-rounded": {
            maxWidth: 500,
            borderRadius: 0
        }
    },
    info: {
        backgroundColor: COLORS.BLUE_50,
        border: "none",
        marginTop: 24,
        padding: "11px 16px",
        alignItems: "flex-start",
        "& .MuiAlert-icon": {
            marginRight: 16
        },
        "& svg": {
            height: 22,
            width: 22
        },
        "& .MuiAlert-message": {
            display: "inline",
            paddingRight: 10,
            lineHeight: "22px"
        },
    }
}))

const ReusableStepModal = ({ open, onClose, onDetach, step, isSection = false }) => {
    const classes = useStyles()

    const handleDetach = () => {
        onDetach && onDetach(step)
        onClose()
    }

    const renderReglages = (objectId) => <a
        style={{ textDecoration: "underline", cursor: "pointer", color: COLORS.BLACK800 }}
        href={objectId ? REUSABLE_STEP_VIEW_URL + objectId : REUSABLE_STEP_URL}
        target="_blank"
        rel="noreferrer"
    >Réglages</a>

    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            className={`${classes.dialog} dialog`}
        >
            <DialogContent sx={{ padding: "24px 24px 8px 24px" }}>
                {isSection ? <>
                    Souhaitez-vous convertir le contenu de la section
                    &nbsp;<b>{step?.name}</b> en étape réutilisable ?
                </> : <>
                    Souhaitez-vous détacher le contenu de la section
                    &nbsp;<b>{step?.name}</b> des étapes réutilisables ?
                </>
                }
                <Alert
                    severity="info"
                    variant="outlined"
                    className={classes.info}
                >
                    <div >
                        {isSection ? <>
                            Une fois l'étape réutilisable créée, vous pourrez l'importer dans une nouvelle recette.<br />
                            Vous pourrez également la modifier à tout moment dans l'onglet
                            &nbsp;{renderReglages(step.objectId)}.
                        </> :
                            <>
                                Vous pouvez également la modifier dans l'onglet
                                &nbsp;
                                {renderReglages(step.objectId)}.
                            </>
                        }
                    </div>
                </Alert>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-between", padding: "8px 24px 24px 24px" }}>
                <Button onClick={onClose} color="primary">
                    Annuler
                </Button>
                <Button onClick={handleDetach} color="primary" variant="contained">
                    {isSection ? "CONVERTIR" : "DÉTACHER"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ReusableStepModal